import { createApiRef } from '@backstage/core-plugin-api';
import {
  CreateVirtualKeyRequest,
  CreateVirtualKeyResponse,
  GatewayModel,
  UsageSummary,
  UsageWindow,
  VirtualKey,
  VirtualKeyUsage,
} from '@internal/backstage-plugin-ai-gateway-keys-common';

export interface AiGatewayKeysApi {
  listModels(): Promise<GatewayModel[]>;
  listKeys(): Promise<VirtualKey[]>;
  createKey(request: CreateVirtualKeyRequest): Promise<CreateVirtualKeyResponse>;
  revokeKey(keyId: string): Promise<VirtualKey>;
  getUsage(keyId: string, window: UsageWindow): Promise<VirtualKeyUsage>;
  getUsageSummary(window: UsageWindow): Promise<UsageSummary>;
}

export const aiGatewayKeysApiRef = createApiRef<AiGatewayKeysApi>({
  id: 'plugin.ai-gateway-keys.service',
});
